export default __webpack_public_path__ + "272de2e64675debb8b12c7b9021ae7f8.png";